import React, { useState, useEffect, useRef } from "react"; 
import { Container, Card, ListGroup, InputGroup, Form, Button } from "react-bootstrap";
import NavBar from './NavBar';
import Fuse from "fuse.js"; // Import fuse.js
import chatData from "./data/datachatbot.json"; // Import JSON data
import "font-awesome/css/font-awesome.min.css";
import "./Chatbotjson.css";

function Chatbotjson({ asset, onClose, onRefresh }) {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showCategories, setShowCategories] = useState(true); // State untuk menampilkan kategori
  const [showFollowUp, setShowFollowUp] = useState(false); // State untuk menampilkan pertanyaan lanjut
  const messageContainerRef = useRef(null);

  const categories = [
    "Program Keluarga Berencana",
    "Kesehatan Reproduksi",
    "Kependudukan",
    "Layanan dan Informasi Lainnya"
  ];

  const followUpQuestions = [
    "Dapatkah Anda menjelaskan lebih lanjut?",
    "Apakah ada informasi lain yang ingin Anda ketahui?",
    "Apakah Anda ingin bertanya tentang topik lain?"
  ];

  const handleCategorySelection = (category) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { text: `Anda memilih kategori: ${category}`, sender: "bot" },
    ]);
    setShowCategories(false); // Sembunyikan kategori setelah dipilih
  };

  // Initialize fuse.js with options for fuzzy search
  const fuse = new Fuse(chatData, {
    keys: ["question"], // Only search in the 'question' field
    threshold: 0.4, // Adjust this threshold for fuzzy matching (lower = stricter)
  });

  const handleSendMessage = () => {
    if (!userInput.trim()) return;

    setMessages([...messages, { text: userInput, sender: "user" }]);
    setIsLoading(true);

    // Use fuzzy search to find the best match for the user input
    const result = fuse.search(userInput);
    const foundResponse = result.length > 0 ? result[0].item.response : null;

    setTimeout(() => {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          text: foundResponse
            ? foundResponse
            : "Maaf, Pertanyaan Anda belum bisa Kami Jawab.",
          sender: "bot",
        },
      ]);
      setIsLoading(false);
      setUserInput("");
      setShowFollowUp(true); // Show follow-up questions after bot responds
    }, 2000);
  };

  const handleFollowUpClick = (question) => {
    setMessages([...messages, { text: question, sender: "user" }]);
    setShowFollowUp(false); // Hide follow-up options after selection
    // Here you can implement logic to handle the follow-up question or use the same fuse logic
    handleSendMessage();
  };

  useEffect(() => {
    setMessages([
      {
        text: "Selamat datang di layanan chatbot BKKBN! Kami siap membantu Anda dengan informasi seputar program keluarga berencana, kesehatan reproduksi, dan kependudukan. Apa yang bisa kami bantu hari ini?",
        sender: "bot",
      },
    ]);
  }, []);

  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
  }, [messages]);

  document.title = "AI Report";

  return (
    <Container fluid className="d-flex justify-content-center align-items-center" style={styles.container}>
      <div>
        <NavBar />
      </div>
      <Card style={styles.card}>
        <Card.Header style={styles.cardHeader}>
          <h4>ChatBot</h4>
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush" style={styles.messageContainer} ref={messageContainerRef}>
            {messages.map((msg, index) => (
              <ListGroup.Item
                key={index}
                style={{
                  ...styles.message,
                  ...(msg.sender === "user" ? styles.userMessage : styles.botMessage),
                }}
              >
                <div style={styles.messageWrapper}>
                  <img
                    src={msg.sender === "bot" ? "/icons/iconbkkbn.png" : "/icons/users.png"}
                    alt={msg.sender}
                    style={styles.icon}
                  />
                  <div style={styles.textWrapper}>
                    <strong>{msg.sender === "bot" ? "BKKBN" : "User"}:</strong>
                    <span dangerouslySetInnerHTML={{ __html: msg.text }} />
                  </div>
                </div>
              </ListGroup.Item>
            ))}

            {showCategories && (
              <ListGroup.Item style={styles.categoryList}>
                <strong>Pilih kategori:</strong>
                <ul>
                  {categories.map((category, index) => (
                    <li key={index}>
                      <Button
                        variant="link"
                        onClick={() => handleCategorySelection(category)}
                        style={styles.categoryButton}
                      >
                        {category}
                      </Button>
                    </li>
                  ))}
                </ul>
              </ListGroup.Item>
            )}

            {showFollowUp && (
              <ListGroup.Item style={styles.categoryList}>
                <strong>Pertanyaan Lanjut:</strong>
                <ul>
                  {followUpQuestions.map((question, index) => (
                    <li key={index}>
                      <Button
                        variant="link"
                        onClick={() => handleFollowUpClick(question)}
                        style={styles.categoryButton}
                      >
                        {question}
                      </Button>
                    </li>
                  ))}
                </ul>
              </ListGroup.Item>
            )}

            {isLoading && (
              <ListGroup.Item className="text-center">
                <span className="typing-animation-pulse">BKKBN is typing</span>
              </ListGroup.Item>
            )}
          </ListGroup>
          
          <InputGroup style={styles.inputGroup}>
            <Form.Control
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Mencegah perilaku default (misalnya, submit form)
                  handleSendMessage();
                }
              }}
              placeholder="Ketik Pertanyaan Anda..."
              style={styles.inputField}
              disabled={showCategories} // Disable input saat kategori belum dipilih
            />
            <Button
              variant="primary"
              onClick={handleSendMessage}
              style={styles.sendButton}
              disabled={showCategories}
            >
              Send
            </Button>
          </InputGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px",
  },
  card: {
    width: "1180px",
    height: "800px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  cardHeader: {
    backgroundColor: "#f0f0f0",
    color: "#000",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "2px",
    padding: "12px",
    textAlign: "center",
    fontfamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  },
  messageContainer: {
    height: "640px",
    overflowY: "auto",
    padding: "10px",
    scrollBehavior: "smooth",
  },
  message: {
    padding: "5px",
    borderRadius: "5px",
    margin: "5px 0",
    maxWidth: "80%",
    wordWrap: "break-word",
    display: "flex",
    alignItems: "center",
  },
  userMessage: {
    backgroundColor: "#e0ffe0", // Warna hijau lembut untuk pesan pengguna
    color: "#333", // Warna teks yang kontras
    alignSelf: "flex-end",
    padding: "10px 15px",
    borderRadius: "15px 15px 0px 15px", // Membulatkan sudut
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Efek bayangan
    display: "flex",
    alignItems: "center", // Sejajarkan ikon dan teks    
    fontSize: "15px",
    maxWidth: "75%", // Batasi lebar pesan
    marginBottom: "10px",
    marginRight: "10px", // Sedikit jarak dengan sisi kanan
  },
  botMessage: {
    backgroundColor: "#f0f4ff", // Warna lembut untuk bot
    color: "#333", // Warna teks yang kontras
    alignSelf: "flex-start",
    padding: "10px 15px",
    borderRadius: "15px 15px 15px 0px", // Membulatkan sudut
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Efek bayangan
    display: "flex",
    alignItems: "center", // Sejajarkan ikon dan teks    
    fontSize: "15px",
    maxWidth: "75%", // Batasi lebar pesan
    marginBottom: "10px",
    marginLeft: "10px", // Sedikit jarak dengan sisi kiri
  },
  messageWrapper: {
    display: "flex",
    alignItems: "flex-start", // Ikon dan teks sejajar di atas
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column", // Teks berurutan secara vertikal
  },
  icon: {
    width: "26px",
    height: "26px",
    marginRight: "10px",
    marginTop: "2px", // Posisi ikon sejajar teks
  },
  inputGroup: {
    marginTop: "10px",
  },
  inputField: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  sendButton: {
    padding: "8px",
    backgroundColor: "#9e8388",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    marginLeft: "10px",
  },
  categoryList: {
    padding: "10px",
    backgroundColor: "#f9f9f9",
    borderRadius: "5px",
  },
  categoryButton: {
    textDecoration: "none",
    color: "#007bff",
    padding: "5px",
  },
};

export default Chatbotjson;
